const timezone = 'America/Los_Angeles'

export function createCalendarEvent (props = { }) {
  const timeStart = props.event_start_date && timezone
    ? formatTime(props.event_start_date, props.event_start_time, timezone)
    : ''
  const timeEnd = props.event_end_time && props.timezone ? 
    formatTime(props.event_end_date || props.date, props.event_end_time, timezone)
    : ''
  const venue = (props.venue ? ' at ' + props.venue : '')

  return encodeURI('data:text/calendar;charset=utf8,' + [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'BEGIN:VEVENT',
    'TZID:' + timezone,
    'X-LIC-LOCATION:' + timezone,
    'URL:' + props.url,
    'DTSTART:' + (timeStart || ''),
    'DTEND:' + (timeEnd || ''),
    'SUMMARY:' + props.title  + venue,
    'DESCRIPTION:' + (props.description || ''),
    'LOCATION:' + (props.address || ''),
    'END:VEVENT',
    'END:VCALENDAR'
  ].join('\n'))
}

function formatTime (date, time) {
  try {
    const time_formatted = time.replace(/:/g, '') + '0000000'
    const formatted = date.replace(/-|:|\.\d+/g, '') + 'T' + time_formatted.substring(0, 6)
    return formatted
  } catch (err) {
    return false
  }
}
